import {DataStatus} from 'platform/components';

import {memo, useCallback, useMemo} from 'react';

import {FeaturePickerItem, FeaturesPicker} from '@dms/shared';

import {Nullish, suffixTestId, TestIdProps} from 'shared/web';

import {useApiEnums} from '../../../../../../hooks/useApiEnums';
import {useFilters} from '../../../FiltersContext/FiltersContext';

export function FilterFeatures(props: TestIdProps) {
  const {getEnum, isLoading, isError} = useApiEnums();
  const {filters, onUpdateFilters} = useFilters();
  const selectedFeatures = useMemo(() => filters.features || [], [filters.features]);
  const featureCategories = useMemo(() => getEnum('feature_category'), [getEnum]);
  const features = useMemo(() => getEnum('feature'), [getEnum]);

  const handleFeatureSelect = useCallback(
    (selected: string[]) => {
      onUpdateFilters('features', selected);
    },
    [onUpdateFilters]
  );

  return (
    <DataStatus isLoading={isLoading} isError={isError}>
      <MemoizedFeaturesPicker
        featureCategories={featureCategories}
        features={features}
        selectedFeatures={selectedFeatures}
        onFeatureSelect={handleFeatureSelect}
        data-testid={props['data-testid']}
      />
    </DataStatus>
  );
}

interface MemoizedFeaturesPickerProps extends TestIdProps {
  featureCategories: FeaturePickerItem[];
  features: FeaturePickerItem[];
  selectedFeatures: string[] | Nullish;
  onFeatureSelect: (selected: string[]) => void;
}

const MemoizedFeaturesPicker = memo((props: MemoizedFeaturesPickerProps) => (
  <FeaturesPicker
    categories={props.featureCategories}
    features={props.features}
    selected={props.selectedFeatures}
    onFeatureSelect={props.onFeatureSelect}
    allowSubItemMultiselect
    data-testid={suffixTestId('features', props)}
  />
));
